import benefitsDataIt from '../data/BenefitsData/benefitsDataIt';
import { BenefitItem, LangData } from '../types/langTypes';

const it: LangData = {
  id: '',
  name: '',
  images: [],
  altText: '',
  description: "",
  portfolioDescription1: "Sito web responsive a pagina singola creato per un marchio di gelato: include la presentazione dei prodotti, la sezione “come è fatto”, una galleria e un modulo di contatto. Realizzato con HTML, CSS (mobile-first) e JavaScript.",
  portfolioDescription2: "Una moderna applicazione e-commerce responsive con UI/UX pulita, filtraggio prodotti in tempo reale, gestione del carrello e layout mobile-first. Tecnologie impiegate: React, TypeScript, Redux e SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Descrizione del portfolio',
  backToTop: 'Torna su',
  mainNavigationLabel: "Navigazione principale",
  mainNavigation: ['Home', 'Chi siamo', 'Servizi', 'Portfolio', 'Contatti'],
  logoTaglines: {
    top: "Pensa audace",
    bottom: "Crea con intelligenza",
  },
  home: "Home",
  about: "Chi siamo",
  aboutmain: "Chi siamo",
  aboutTitle: "CHI SIAMO",
  aboutSubtitle: "Architetti della superiorità digitale",
  aboutText: "SYDRIX è il punto in cui l'estetica ingegneristica incontra l'efficienza aziendale. Fondato da un visionario tecnologico ucraino nel cuore della Baviera, il nostro studio è sinonimo di resilienza digitale e innovazione. Non sviluppiamo solo interfacce: creiamo asset digitali che superano il mercato. Il nostro approccio si basa su tre pilastri: Performance-First (la velocità come religione), Inclusive Design (l'accessibilità come standard) e Scalable Architecture (pronti per una crescita decuplicata). Crediamo che il codice perfetto debba essere invisibile, ma il risultato deve essere tangibile in ogni rapporto sugli utili. Con SYDRIX, ottieni un vantaggio tecnologico che trasforma il tuo marchio in un leader dell'era digitale.",
  aboutPhilosophyTitle: "La nostra filosofia",
  aboutPhilosophyText: "Sostituiamo i vecchi metodi con una prospettiva fresca sulla performance. Il nostro approccio garantisce un'architettura solida nel tempo.",
  aboutButton: "Scopri di più",
  aboutButtonText: "Visualizza",
  aboutButtonLink: "/about",
  aboutImageAlt: "Immagine chi siamo",
  aboutList: ["Team professionale", "Tecnologie moderne", "Approccio individuale"],
  aboutQuote: "Amiamo ciò che facciamo!",
  aboutQuoteAuthor: "Fondatore del team",
  aboutStats: [
    { label: "Stack tecnologico", value: "Next.js" },
    { label: "Focus qualità", value: "100%" }
  ],
  aboutMission: "Trasformiamo tecnologie complesse nei vostri asset strategici, assicurando la leadership aziendale nell'era digitale.",
  aboutVision: "Diventare il punto di riferimento globale per l'ingegneria frontend, dove ogni pixel lavora per il profitto del cliente.",
  aboutValues: ["Eccellenza ingegneristica", "Trasparenza radicale", "Innovazioni scalabili"],
  aboutTeam: "Il nostro team è la nostra risorsa principale.",
  aboutPartners: "I nostri partner si fidano di noi.",
  aboutClients: "I nostri clienti sono i nostri amici.",
  aboutHistory: "La storia dell'azienda è iniziata nel 2025.",
  services: "Servizi",
  servicesTitle: "I nostri servizi",
  servicesContactText: "Contattaci per maggiori dettagli",
  servicesButton: "Scopri di più",
  servicesFormTitle: "Ricevi una consulenza gratuita",
  servicesFormPlaceholder: "La tua email",
  servicesFormButton: "Invia",
  showLessButton: "Mostra meno",

  portfolio: "Portfolio",
  portfolioTitle: "Portfolio",
  portfolioText: "Idee realizzate",
  portfolioLabel: "Portfolio",
  viewOnGithub: "Vedi su GitHub",
  noProjectsFound: "Nessun progetto trovato.",

  testimonials: "Testimonianze",
  testimonialsText: "Grazie a tutti i nostri clienti per i feedback!",
  blogTitle: "Blog",
  contacts: "Contatti",
  contactsTitle: "Contatti",
  phone: "Telefono",
  email: "E-mail",
  faq: "Domande frequenti",
  partnership: "Collaborazione",
  showAllButton: "Mostra tutto",
  showMoreButton: "Mostra di più",
  hideAllButton: "Nascondi",
  title: "Sviluppo frontend per la tua azienda",
  subtitle: [
    "Velocità impressionante.",
    "Design memorabile.",
    "Esperienza coinvolgente.",
  ],
  button: "Parliamone",
  benefitsTitle: "Vantaggi della collaborazione",
  benefitsSubtitle: "Perché i clienti ci scelgono",
  benefitsText: "Creiamo siti web veloci, sicuri ed efficienti.",
  benefits: benefitsDataIt,
  goTo: "vai a",
  footer: "Sviluppato da Artem Sydorov",
  heroTitle: "Sviluppo frontend per la tua azienda",
  heroSubtitle: [
    "Velocità impressionante.",
    "Design memorabile.",
    "Esperienza coinvolgente.",
  ],
  heroButton: "Parliamone",
  portfolioLink: "/portfolio",
  portfolioLinkText: "Guarda il portfolio",
  serviceDetailsTitle: "Dettagli del servizio",
  serviceDetailsText: "Informazioni dettagliate sui nostri servizi.",
  servicesDetailsButton: "Scopri di più sul servizio",
  servicesDetailsSubtitle: "Ulteriori informazioni sui nostri servizi",
  servicesDetailsList: ["Servizio 1", "Servizio 2", "Servizio 3"],
  notFoundTitle: "Pagina non trovata",
  notFoundText: "Siamo spiacenti, questa pagina non esiste.",
  notFoundButton: "Torna alla home",
  cookieConsentText:
    "Questo sito utilizza i cookie per migliorare l'esperienza dell'utente.",
  cookieConsentButton: "Capito",
  privacyPolicy: "Informativa sulla privacy",
  termsOfService: "Termini di servizio",
  loading: "Caricamento...",
  error: "Si è verificato un errore. Riprova.",
  success: "Successo!",
  language: "Lingua",
  selectLanguage: "Seleziona lingua",
  close: "Chiudi",
  serviceDetailsBack: "Torna ai servizi",
  faqTitle: "Domande frequenti",
  faqSubtitle: "Risposte alle domande più comuni",
  faqText:
    "Se hai una domanda, consulta questa sezione o contattaci.",
  team: "Team",
  teamTitle: "Il nostro team",
  teamText: "Siamo un team di professionisti appassionati.",
  process: "Processo",
  processTitle: "Come lavoriamo",
  processText: "Seguiamo un processo di sviluppo trasparente.",
  technologies: "Tecnologie",
  technologiesTitle: "Tecnologie che utilizziamo",
  technologiesText: "Utilizziamo framework e strumenti moderni.",
  price: "Prezzi",
  priceTitle: "Prezzi dei servizi",
  priceText: "Scopri di più sui nostri prezzi.",
  processSubtitle: "Fasi del nostro lavoro",
  teamSubtitle: "Conosci il nostro team",
  teamButton: "Scopri di più sul team",
  teamButtonText: "Guarda il team",
  processButton: "Scopri il processo",
  processButtonText: "Guarda il processo",
  technologiesSubtitle: "Le nostre tecnologie",
  technologiesButton: "Scopri di più sulle tecnologie",
  technologiesButtonText: "Guarda le tecnologie",
  priceSubtitle: "Dettagli sui prezzi",
  priceButton: "Scopri di più sui prezzi",
  priceButtonText: "Guarda i prezzi",
  teamButtonLink: "/team",
  portfolioButton: "Scopri di più sul portfolio",
  portfolioButtonText: "Guarda il portfolio",
  portfolioButtonLink: "/portfolio",
  blogButton: "Scopri di più sul blog",
  blogButtonText: "Guarda il blog",
  blogButtonLink: "/blog",
  contactsButton: "Scopri di più sui contatti",
  contactsButtonText: "Guarda i contatti",
  contactsButtonLink: "/contacts",
  faqButton: "Scopri di più sulle FAQ",
  faqButtonText: "Guarda le FAQ",
  faqButtonLink: "/faq",
  notFoundButtonText: "Torna alla home",
  cookieConsentMore: "Scopri di più",
  privacyPolicyButton: "Guarda l'informativa",
  termsOfServiceButton: "Guarda i termini",
  contactsButtonLinkText: "Vai ai contatti",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "Guarda l'informativa sulla privacy",
  termsOfServiceButtonText: "Guarda i termini di servizio",
  aboutButtonLinkText: "Scopri di più su di noi",
  servicesButtonLinkText: "Scopri di più sui servizi",
  portfolioButtonLinkText: "Scopri di più sul portfolio",
  blogButtonLinkText: "Scopri di più sul blog",
  faqButtonLinkText: "Scopri di più sulle FAQ",
  teamButtonLinkText: "Scopri di più sul team",
  processButtonLinkText: "Scopri di più sul processo",
  technologiesButtonLinkText: "Scopri di più sulle tecnologie",
  priceButtonLinkText: "Scopri di più sui prezzi",
  notFoundButtonLinkText: "Torna alla home",
  cookieConsentButtonText: "Capito",
  cookieConsentMoreText: "Scopri di più",
  faqQuestion: "Domanda",
  faqAnswer: "Risposta",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",
  partnershipTitle: "Collaborazione",
  partnershipSubtitle: "Opportunità di collaborazione",
  partnershipText: "Siamo aperti a collaborazioni e nuove opportunità.",
  notFoundBackButton: "Torna indietro",
  extraField1: "Campo aggiuntivo 1",
  extraField2: "Campo aggiuntivo 2",
  notFoundLink: "/",
  cookieConsent: "Questo sito utilizza i cookie per migliorare l'esperienza utente.",
  toggleMenu: "Apri/chiudi menu",
  noPortfolioItems: 'Il portfolio è attualmente vuoto',
  noImages: 'Nessuna immagine disponibile',
  "impressum.back": "Indietro",
  "impressum.subtitle": "Note Legali",
  "impressum.infoTitle": "Informazioni ai sensi del § 5 TMG",
  "impressum.owner": "Titolare",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Germania",
  "impressum.contactTitle": "Contatti",
  "impressum.email": "E-mail",
  "impressum.website": "Sito web",
  "impressum.copyrightTitle": "Diritto d'autore",
  "impressum.rights": "Tutti i diritti riservati.",
  "impressum.disputeTitle": "Risoluzione delle controversie",
  "impressum.disputeText": "La Commissione Europea fornisce una piattaforma per la risoluzione delle controversie online (OS):",
  "impressum.disputeFinal": "Non sono obbligato a partecipare a procedimenti di risoluzione delle controversie dinanzi a un organo di arbitraggio per i consumatori.",
  "impressum.disclaimerTitle": "Esclusione di responsabilità",
  "impressum.disclaimerText": "Responsabilità per i contenuti: I contenuti delle nostre pagine sono stati creati con la massima cura. Tuttavia, non possiamo garantire l'accuratezza o l'attualità delle informazioni. Come fornitori di servizi, siamo responsabili dei nostri contenuti su queste pagine. Responsabilità per i link: Il nostro sito contiene link a siti web esterni di terzi, sui cui contenuti non abbiamo alcuna influenza e pertanto non possiamo assumere alcuna responsabilità.",
  "impressum.taxStatus": "Ai sensi del § 19 UStG, l'IVA non viene applicata (regime delle piccole imprese).",
  "impressum.responsible": "Responsabile dei contenuti ai sensi del § 18 MStV",
  "impressum.phone": "Telefono",
  "impressum.copyrightText": "I contenuti e le opere creati dal gestore del sito su queste pagine sono soggetti al diritto d'autore. La riproduzione, l'elaborazione, la distribuzione e qualsiasi tipo di utilizzo al di fuori dei limiti del diritto d'autore richiedono il consenso scritto dell'autore.",
  "impressum.copyrightLinkText": "Legge tedesca sul diritto d'autore (UrhG)",

  "privacy.title": "Informativa sulla privacy",
  "privacy.intro": "Prendo molto seriamente la protezione dei vostri dati personali. Questo sito web è progettato per elaborare il minor numero di dati possibile.",
  "privacy.hostingTitle": "1. Hosting esterno",
  "privacy.hostingText": "Questo sito web è ospitato da un fornitore di servizi esterno (hoster). I dati personali raccolti su questo sito sono memorizzati sui server dell'hoster. Ciò include principalmente indirizzi IP e metadati. L'impiego dell'hoster avviene nell'interesse di una fornitura sicura e rapida della nostra offerta online da parte di un fornitore professionale (Art. 6 par. 1 lett. f del GDPR).",
  "privacy.dataTitle": "2. Minimizzazione dei dati",
  "privacy.dataText": "Nell'ottica della minimizzazione dei dati, questo sito rinuncia all'uso di cookie, strumenti di analisi (tracking) e moduli di contatto. Non viene effettuata alcuna valutazione del comportamento dell'utente.",
  "privacy.rightsTitle": "3. Diritti dell'interessato",
  "privacy.rightsText": "Nell'ambito delle disposizioni di legge vigenti, avete il diritto in qualsiasi momento di ricevere informazioni gratuite sui vostri dati personali memorizzati, nonché il diritto alla rettifica o alla cancellazione di tali dati.",
  "privacy.contactTitle": "4. Titolare del trattamento",
  "privacy.contactText": "Il responsabile del trattamento dei dati è Artem Sydorov. I dati di contatto completi sono disponibili nell'Impressum di questo sito.",
};

export default it;
